import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type FeedbackConfigFragment = { status?: Types.FeedbackConfigStatusEnum | null, surveyId?: string | null, scheduleInformation?: { operator?: Types.RelativeDateFilterOperatorEnum | null, type?: Types.DueDateTypeEnum | null, unit?: Types.RelativeDateFilterUnitEnum | null, value?: number | null } | null, questions?: Array<{ type: Types.DatabaseFieldTypeEnum, text: string, questionId?: string | null }> | null };


export type FeedbackConfigFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const FeedbackConfigFragmentDoc = /*#__PURE__*/ gql`
    fragment FeedbackConfig on FeedbackConfigType {
  status
  surveyId
  scheduleInformation {
    operator
    type
    unit
    value
  }
  questions {
    type
    text
    questionId
  }
}
    `;